module.exports = __webpack_public_path__ + "static/media/upload.4239b897.svg";